import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use(async (config) => {
  const token = localStorage.getItem("pp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const isImport = (config.method || "").toLowerCase() === "post" && /\/import(\?|$)/.test(config.url || "") && typeof FormData !== "undefined" && config.data instanceof FormData && !config.params?.mode;
  if (isImport) {
    const { askImportMode } = await import("./importMode");
    const file = [...config.data.values()].find((v) => v && typeof v === "object" && "name" in v);
    const choice = await askImportMode(file?.name, config.url || "");
    if (!choice) throw new axios.Cancel("Upload cancelled");
    config.params = { ...(config.params || {}), mode: choice.mode, filename: file?.name };
  }
  return config;
});

api.interceptors.response.use((res) => {
  const b = res?.data?.import_batch;
  if (b && res.config?.params?.mode) {
    import("sonner").then(({ toast }) => toast.info(`Upload saved · ${b.inserted} row(s) added${b.replaced ? `, ${b.replaced} previous row(s) replaced` : ""}`, {
      duration: 15000,
      action: { label: "Undo this upload", onClick: () => api.post(`/imports/batches/${b.id}/undo`).then(({ data }) => { toast.success(`Upload undone — ${data.deleted} row(s) removed${data.restored ? `, ${data.restored} restored` : ""}. Refresh the page.`); }).catch((e) => toast.error(errMsg(e))) },
    }));
  }
  return res;
});

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
